// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/store'
import VueI18n from 'vue-i18n'
import translations from './data/translations'
import Vue2Filters from 'vue2-filters'
import * as FastClick from 'fastclick'
import VueTouch from 'vue-touch'
import { currentUserInfo } from './lib/kronolog-client'

import AudioPlayer from './components/shared/audio-player.vue'
Vue.component('audio-player', AudioPlayer)

// Import and use vue-awesome
import Icon from 'vue-awesome/components/Icon.vue'
Vue.component('icon', Icon)

import 'vue-awesome/icons/volume-up'
import 'vue-awesome/icons/volume-off'
import 'vue-awesome/icons/check-circle'
import 'vue-awesome/icons/times-circle'
import 'vue-awesome/icons/question-circle'
import log from './lib/logger'

// Load vue plugins
Vue.use(Vue2Filters)
Vue.use(VueI18n)
Vue.use(VueTouch, {name: 'v-touch'})

Vue.config.productionTip = false

// Router beforeEach (global) navigation guards
router.beforeEach((to, from, next) => {
  /* AUTH
   *  For all other than login: Must be logged in
   *  For all tasks: Must have given consent
   *  For each task: Task must be current task in state
   */

  currentUserInfo().then(
    response => {
      // User is logged in, send to next task
      log.debug('Logged in')
      var tasks = ['srt', 'crt', 'dsb', 'dsf', 'vm', 'vismem', 'mst', 'pst', 'cod']
      var isTask = tasks.indexOf(to.path.substr(1))
      // If going to a task, is it the correct one according to state?
      if (isTask >= 0) {
        log.debug('[Router] Got a task navigation request')
        if (store.state.user.consent_given_at === null) {
          log.warn('[Router] Task navigation request REJECTED: No consent')
          router.replace('/dash')
          return null
        }
        if (to.path.substr(1) !== store.getters.currentTask) {
          log.warn('[Router] Task navigation request REJECTED: No not matching state (' + store.getters.currentTask + ')')
          router.replace('/dash')
          return null
        }
      }
    },
    error => {
      // User is not logged in, send to login
      log.debug(error)
      log.info('Not logged in, sending user to login-page')
      router.push('/login')
    })
  log.debug('[Router] *NAV* From: ' + from.path + ' To: ' + to.path)
  next()
})

// Router afterEach (global) navigation guards
router.afterEach((to, from, next) => {
  log.info('[Router] Navigated from: ' + from.path + ' to: ' + to.path)
})

// Create VueI18n instance with options
const i18n = new VueI18n({
  locale: 'no', // set locale
  messages: translations
})

// eslint-disable-next-line
var vm = new Vue({
  el: '#app',
  router,
  store,
  i18n,
  template: '<App/>',
  components: { App }
})

// Bind FastClick to body to remove 300ms delay in old mobile browsers
FastClick['attach'](document.body)

// Handle browser navigate away (deactivates when user logs out)
window.onbeforeunload = function () {
  log.info('User may have closed tab.')
  if (window.dirty) {
    return 'Are you sure you want to navigate away?'
  }
}
window.unload = function () {
  // Do something before unload?
  // e.g. send notice to server and invalidate login/session
  log.debug('Leaved page...')
}



// WEBPACK FOOTER //
// ./src/main.js